export const PREDICTION_MARKET_MDS_THROTTLE = '250ms';
